module.exports = __webpack_public_path__ + "b02bdc1b846fd65473922f5f62832108.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/theme-default/fonts/element-icons.ttf?t=1472440741
// module id = 674
// module chunks = 0